import { render, staticRenderFns } from "./canceled.vue?vue&type=template&id=483d7d5e"
import script from "./canceled.vue?vue&type=script&lang=js"
export * from "./canceled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports